import * as Icons from "lucide-react";
import { Check } from "lucide-react";

export default function Amenities({ amenities = [] }) {
  const list = amenities.length ? amenities : DEFAULT_LIST;
  return (
    <section id="amenities" className="py-24 md:py-32 bg-[#EFEAE4]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-14 reveal">
          <div className="text-[11px] uppercase tracking-[0.35em] text-[#985F47] mb-5">Amenities</div>
          <h2 className="serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tightest text-[#2C392F] font-light">
            Everything you need <span className="italic text-[#985F47]">for an easy stay.</span>
          </h2>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-5">
          {list.map((a, i) => {
            const Icon = (a.icon && Icons[a.icon]) || Check;
            return (
              <li
                key={a.id || a.label || i}
                data-testid={`amenity-${i}`}
                className="reveal flex items-center gap-4 py-4 border-b border-[#2C392F]/10"
              >
                <span className="h-10 w-10 rounded-full bg-[#F7F5F0] border border-[#2C392F]/15 flex items-center justify-center flex-shrink-0">
                  <Icon size={18} className="text-[#6A7B61]" strokeWidth={1.5} />
                </span>
                <span className="text-[15px] md:text-base text-[#1A1C1A] leading-snug">{a.label}</span>
              </li>
            );
          })}
        </ul>

        <p className="mt-10 text-[12px] text-[#4A4D4A] italic max-w-2xl">
          Amenities are listed in good faith. Anything specific to your stay can be confirmed at the time
          of enquiry.
        </p>
      </div>
    </section>
  );
}

const DEFAULT_LIST = [
  { label: "Full-time caretaker", icon: "UserRound" },
  { label: "Home-cooked meals on request", icon: "UtensilsCrossed" },
  { label: "Modern bathrooms and fittings", icon: "Bath" },
  { label: "Comfortable bedrooms", icon: "BedDouble" },
  { label: "Living and dining spaces", icon: "Sofa" },
  { label: "Kitchen access or assisted meals", icon: "ChefHat" },
  { label: "Large private compound", icon: "Trees" },
  { label: "Orchard and garden", icon: "Leaf" },
  { label: "Outdoor seating areas", icon: "Armchair" },
  { label: "Grocery store outside the gate", icon: "ShoppingBasket" },
  { label: "Wi-Fi", icon: "Wifi" },
  { label: "Parking", icon: "Car" },
  { label: "Housekeeping", icon: "Sparkles" },
  { label: "Power backup", icon: "Zap" },
  { label: "Hot water", icon: "Droplets" },
  { label: "Linen and towels", icon: "Shirt" },
];
